import React, { useState } from 'react';
import {
    Container,
    Typography,
    Box,
    TextField,
    MenuItem,
    Button,
    Paper,
} from '@mui/material';
import { unSubscribeUserApi } from '../../redux/action/user';
import SnackBar from '../../atoms/snackBar';
import { useLocation, useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';

const reasons = [
    "The emails are too frequent",
    "I no longer want to receive these emails",
    "The content is not relevant to me",
    "I didn’t sign up for these emails",
    "I’m receiving duplicate emails",
    "I found a better alternative",
    "I’m taking a break",
    "Other(please specify)"
];

const UnSubscribe = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');

    const [reason, setReason] = useState('');
    const [feedback, setFeedback] = useState('');
    const [loading, setLoading] = useState(false);
    const [openSnackBar, setOpenSnackBar] = useState({
        open: false,
        message: '',
        severity: ''
    })

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        setLoading(true)
        e.preventDefault();
        try {
            const payload = {
                content: reason === reasons.at(-1) ? 'other' : reason,
                custom_reason: feedback ? feedback : null
            }
            const res = await unSubscribeUserApi(payload, token);
            setOpenSnackBar({
                open: true,
                message: res?.data?.message,
                severity: 'success'
            });
            navigate('/unsubscribe/success');
        } catch (error) {
            setOpenSnackBar({
                open: true,
                message: error?.message,
                severity: 'error'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Container maxWidth="sm">
                <Paper elevation={3} sx={{ padding: 4, mt: 6 }}>
                    <Typography variant="h4" textAlign="center" gutterBottom>
                        Unsubscribe
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        We're sorry to see you go. Please let us know why you're unsubscribing.
                    </Typography>

                    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3, mx: 0, px: 0 }}>
                        <TextField
                            fullWidth
                            select
                            label="Reason for unsubscribing"
                            value={reason}
                            onChange={(e) => {
                                setReason(e.target.value)
                                setFeedback('')
                            }}
                            required
                            margin="normal"
                            variant="outlined"
                        >
                            {reasons.map((option) => (
                                <MenuItem key={option} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </TextField>

                        {reason === reasons.at(-1) && (
                            <TextField
                                fullWidth
                                label="Additional comments (optional)"
                                multiline
                                required
                                rows={3}
                                value={feedback}
                                onChange={(e) => setFeedback(e.target.value)}
                                margin="normal"
                                variant="outlined"
                            />
                        )}

                        <Button
                            type="submit"
                            variant="contained"
                            fullWidth
                            sx={{
                                mt: reason === reasons.at(-1) ? 6 : 3,
                                backgroundColor: '#e29c2e',
                                '&:hover': {
                                    backgroundColor: '#e29c2e',
                                },
                            }}
                            disabled={loading}
                        >
                            Unsubscribe
                        </Button>

                    </Box>
                </Paper>
            </Container>

            <SnackBar
                open={openSnackBar.open}
                message={openSnackBar.message}
                severity={openSnackBar.severity}
                handleCloseSnackBar={() => {
                    setOpenSnackBar({
                        open: false,
                        message: '',
                        severity: ''
                    })

                }}
            />
        </>
    );
};

export default UnSubscribe;
